import threadArchive from '@/graphql/threads/threadArchive.gql'
import threadUnarchive from '@/graphql/threads/threadUnarchive.gql'

export default class ThreadGql {
  constructor ({ $apollo }) {
    this.$apollo = $apollo
  }

  archive (tenantId, threadId) {
    return this.$apollo.mutate({
      mutation: threadArchive,
      variables: {
        tenantId,
        threadId
      }
    })
  }

  unarchive (tenantId, threadId) {
    return this.$apollo.mutate({
      mutation: threadUnarchive,
      variables: {
        tenantId,
        threadId
      }
    })
  }
}
